import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";

const ConfirmationDialog = ({
  open,
  title = "Are you sure?",
  content = "Would you like to remove this item from the list?",
  onClose,
  onConfirm,
  successMessage = "Action completed successfully!",
  errorMessage = "Something went wrong!",
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    setLoading(true);

    setTimeout(async () => {
      try {
        await onConfirm(); // <-- must return promise
      
        onClose(true);
      } catch (error) {
        console.error("Confirmation error:", error);
        onClose(false);
      } finally {
        setLoading(false);
      }
    }, 2000); // ⏳ 2s loader
  };

  return (
    <Dialog open={open} onClose={() => !loading && onClose(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onClose(false)}
          color="error"
          variant="outlined"
          size="small"
          disabled={loading}
        >
          No
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          size="small"
          disabled={loading}
          startIcon={
            loading ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {loading ? "Processing..." : "Yes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
